import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3 text-primary" }, "略歴", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "mark p-2" }, "職歴", -1)
const _hoisted_5 = { class: "row p-2" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", { class: "mark p-2" }, "学歴", -1)
const _hoisted_9 = { class: "row p-2" }
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", { class: "mark p-2" }, "外部資金", -1)
const _hoisted_13 = { class: "row p-2" }
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h4", { class: "mark p-2" }, "受賞など", -1)
const _hoisted_17 = { class: "row p-2" }
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h4", { class: "mark p-2" }, "アウトリーチ", -1)
const _hoisted_21 = { class: "row p-2" }
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h4", { class: "mark p-2" }, "担当講義", -1)
const _hoisted_25 = { class: "row p-2" }
const _hoisted_26 = { class: "col-md-3" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h4", { class: "mark p-2" }, "その他", -1)
const _hoisted_29 = { class: "row p-2" }
const _hoisted_30 = { class: "col-md-3" }
const _hoisted_31 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("dl", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employments, (employment, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("dt", _hoisted_6, _toDisplayString(employment.period), 1),
            _createElementVNode("dd", {
              class: "col-md-9",
              innerHTML: employment.job
            }, null, 8, _hoisted_7)
          ], 64))
        }), 128))
      ]),
      _hoisted_8,
      _createElementVNode("dl", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.educations, (education, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("dt", _hoisted_10, _toDisplayString(education.date), 1),
            _createElementVNode("dd", {
              class: "col-md-9",
              innerHTML: education.text
            }, null, 8, _hoisted_11)
          ], 64))
        }), 128))
      ]),
      _hoisted_12,
      _createElementVNode("dl", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grants, (grant, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("dt", _hoisted_14, _toDisplayString(grant.period), 1),
            _createElementVNode("dd", {
              class: "col-md-9",
              innerHTML: grant.text
            }, null, 8, _hoisted_15)
          ], 64))
        }), 128))
      ]),
      _hoisted_16,
      _createElementVNode("dl", _hoisted_17, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.awards, (award, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("dt", _hoisted_18, _toDisplayString(award.date), 1),
            _createElementVNode("dd", {
              class: "col-md-9",
              innerHTML: award.text
            }, null, 8, _hoisted_19)
          ], 64))
        }), 128))
      ]),
      _hoisted_20,
      _createElementVNode("dl", _hoisted_21, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.outreaches, (outreach, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("dt", _hoisted_22, _toDisplayString(outreach.date), 1),
            _createElementVNode("dd", {
              class: "col-md-9",
              innerHTML: outreach.text
            }, null, 8, _hoisted_23)
          ], 64))
        }), 128))
      ]),
      _hoisted_24,
      _createElementVNode("dl", _hoisted_25, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lectures, (lecture, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("dt", _hoisted_26, _toDisplayString(lecture.year) + "年度 " + _toDisplayString(lecture.semester) + "セメスター", 1),
            _createElementVNode("dd", {
              class: "col-md-9",
              innerHTML: lecture.text
            }, null, 8, _hoisted_27)
          ], 64))
        }), 128))
      ]),
      _hoisted_28,
      _createElementVNode("dl", _hoisted_29, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.etcs, (etc, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("dt", _hoisted_30, _toDisplayString(etc.date), 1),
            _createElementVNode("dd", {
              class: "col-md-9",
              innerHTML: etc.text
            }, null, 8, _hoisted_31)
          ], 64))
        }), 128))
      ])
    ])
  ]))
}